import { global_locales } from 'components/constants'
import { ReactNode } from 'react'
import styled from 'styled-components'
const locales = global_locales.timestamp
export const TimeStamp = ({
  children,
  lang,
}: {
  children: ReactNode
  lang: 'de' | 'fr'
}) => {
  return (
    <TimeStampRoot>
      <BG>
        {locales[lang].type}: {children}
      </BG>
    </TimeStampRoot>
  )
}

const TimeStampRoot = styled.div`
  width: 100%;
  font-size: 12px;
  margin-bottom: 5px;
  /* font-style: italic; */
  line-height: 1em;
`
const BG = styled.div`
  display: inline-block;
  /* background-color: var(--beige-bright-2);
  background-color: var(--site-background); */
  border: 1px solid var(--timestamp-border);
  color: var(--timestamp-color);
  padding: 6px 8px;
  border-radius: 2px;
`
